import BaseComponent from "@js/components/base_component.jsx";

class EuiReceivingDomainsIndexTable extends BaseComponent {

  render() {
    return ( this.props.table && this.props.table.length > 0 ) ? (
      <table className="table table-hover">
        <thead>
          <tr>
            <th className="column-name">{ t("headings.domain") }</th>
            <th className="column-name text-center" style={{width: "80px"}}>{ t("headings.dns") }</th>
            <th className="column-actions" style={{width: "100px"}}>&nbsp;</th>
          </tr>
        </thead>
        <tbody>{this._renderRows()}</tbody>
      </table>
    ) : this.props.filtered ? (
      <EmptyTableNotification
        text={ I18n.t("phrases.no_receiving_domains_match") }
        offerNew={ false }
      />
    ) : (
      <EmptyTableNotification
        type={I18n.t("sections.receiving_domains")}
        offerNew={ true }
      />
    );
  }

  _renderRows() {
    return this.props.table.map((rd, i) => {
      return (
        <tr key={ i }>
          <td>{ rd.domain }</td>
          <td className="text-center">
            { !rd.dns_verified
              ? <span className="text-muted"><i className="fa fa-times" /></span>
              : ( rd.dns_regression
                  ? <span className="text-muted"><i className="fa fa-check" /> <TooltipLink text={ <i className="fa fa-exclamation-triangle text-muted" /> } tooltip={ I18n.t("phrases.dns_status_regression_note") } /></span>
                  : <span className="text-muted"><i className="fa fa-check" /></span>
                )
            }
          </td>
          <td className="text-right index-buttons">
            { rd.id && (
              <div>
                <ButtonView
                  href={ Routes.eui_receiving_domain_path(rd.id) }
                  size="small"
                />
              </div>
            )}
          </td>
        </tr>
      );
    });
  }

}

export default EuiReceivingDomainsIndexTable;
